import { WisePayout } from "@/api/pb/Wise/Common/WisePayout"
import { WisePayoutStatus } from "@/api/pb/Wise/Common/WisePayoutStatus"
import dayjs from "dayjs"

export type HRWisePayout = {
  id: string
  status: string
  transactionDate: string
  amount: string
}

export const mapToHumanRedable = (payout: WisePayout): HRWisePayout => {
  const statusToText: Record<WisePayoutStatus, string> = {
    [WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_UNKNOWN]: "wiseHistoryProcessing",
    [WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_PENDING]: "wiseHistoryProcessing",
    [WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_TRANSFERRED]: "wiseHistoryTransferred",
    [WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_CANCELLED]: "wiseHistoryCancel",
    [WisePayoutStatus.UNRECOGNIZED]: "異常ステータス",
  }
  return {
    id: payout.id,
    status: statusToText[payout.status],
    transactionDate: dayjs(payout.transferRequestedAt).format("YYYY/MM/DD"),
    amount: payout.amount,
  }
}